import { cn } from '@/lib/utils'

type ButtonVariant = 'primary' | 'outline' | 'light' | 'outline-light'
type ButtonSize = 'sm' | 'md' | 'lg'

interface ButtonStyleOptions {
    variant?: ButtonVariant
    size?: ButtonSize
    className?: string
}

const VARIANTS: Record<ButtonVariant, string> = {
    primary: 'bg-primary text-primary-foreground shadow-lg shadow-primary/25 hover:-translate-y-0.5 hover:bg-primary/90 hover:shadow-xl hover:shadow-primary/30',
    outline: 'border border-foreground/15 bg-card/80 text-foreground hover:-translate-y-0.5 hover:border-foreground/30 hover:bg-card',
    light: 'bg-background text-foreground shadow-lg shadow-black/10 hover:-translate-y-0.5 hover:bg-card',
    'outline-light': 'border border-background/25 text-background hover:-translate-y-0.5 hover:border-background/50 hover:bg-background/10'
}

const SIZES: Record<ButtonSize, string> = {
    sm: 'min-h-9 px-4 py-1.5 text-sm',
    md: 'min-h-11 px-5 py-2 text-sm',
    lg: 'min-h-13 px-7 py-3 text-base'
}

export const buttonStyles = ({ variant = 'primary', size = 'md', className }: ButtonStyleOptions = {}): string =>
    cn(
        'inline-flex items-center justify-center gap-2 rounded-full text-center font-semibold transition-all duration-200 outline-none focus-visible:ring-[3px] focus-visible:ring-ring/40 disabled:pointer-events-none disabled:opacity-60 motion-reduce:transition-none motion-reduce:hover:translate-y-0 [&_svg]:size-4 [&_svg]:shrink-0',
        VARIANTS[variant],
        SIZES[size],
        className
    )
